<template>
    <div class="roleSetting"
      v-loading="showLoad"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <iframe class="register-iframe" :src="roleSettingUrl" frameborder="0" @load="iframeLoad"
        ></iframe>
    </div>
</template>


<script>
import Url from "../../../service/base-url.js";
import { mapState } from "vuex";
export default {
  name: "roleSetting",
  data() {
    return {
      showLoad: true
    };
  },
  methods: {
    iframeLoad() {
      this.showLoad = false;
    }
  },
  computed: {
    ...mapState(["loginUser"]),
    roleSettingUrl() {
      return (
        Url.baseUrl +
        "/MenuPermissionConfiguration/role/Units2?appid=" +
        "1709121847530000101"
      );
    }
  }
};
</script>
<style lang="stylus" scoped>
.roleSetting
  height: 100%;
  .register-iframe
    width: 100%;
    height: 100vh;
</style>
